// Last-known-good snapshots of Convex read payloads, persisted to localStorage so
// the app can render real data (not a spinner) on a cold start while offline.

import { useOfflineStore } from '@/store/offline.store'

const PREFIX = 'offline-cache:'

export function readSnapshot<T>(key: string): T | null {
  try {
    const raw = localStorage.getItem(PREFIX + key)
    if (!raw) return null
    return JSON.parse(raw) as T
  } catch {
    return null
  }
}

export function writeSnapshot<T>(key: string, data: T): void {
  try {
    localStorage.setItem(PREFIX + key, JSON.stringify(data))
  } catch {
    // Quota exceeded or serialization failure — ignore, cache is best-effort.
  }
}

/** Wipe every cached snapshot. Call on sign-out / account deletion. */
export function clearOfflineCache(): void {
  try {
    for (const k of Object.keys(localStorage)) {
      if (k.startsWith(PREFIX)) localStorage.removeItem(k)
    }
  } catch {
    // ignore
  }
}

/** Wipe cached snapshots and the pending mutation queue. */
export function clearOfflineData(): void {
  clearOfflineCache()
  useOfflineStore.getState().clear()
}
